import { getRandomInt, trace } from 'rytm-helpers';
import * as THREE from 'three';
import { Line2 } from 'three/addons/lines/Line2.js';
import { LineMaterial } from 'three/addons/lines/LineMaterial.js';
import { LineGeometry } from 'three/addons/lines/LineGeometry.js';
import gsap from 'gsap';

import { getAccentSoundAnalyserData } from './mixer'

class Shape {
  /**
  * class constructor  
  * @constructor
  **/
  constructor( params ) {
    this.params = params;
    this.length = params.length;
    this.visible = false;
    this.frame = 0;
    this.stamina = 0; // the length of line (0—1)
    this.materialVisible = false; // fix for mobile dotts (material visibility)
    this.currentStamina = 0; // current stamina
    this.staminaPeak = false; // has stamina hit 1?
    this.staminaFalls = false; // is stamina decreasing?
    this.staminAnimation = this._getLineStaminaAnimation(this);
    this._generateLine();
  }
  _getStartPoint() {
    const p = this.params
    const f = this.staminaFalls ? (1 - this.stamina) : 0;
    const x1 = Math.cos(p.angle) * this.length * f;
    const y1 = Math.sin(p.angle) * this.length * f;
    return {
      x: p.x + x1,
      y: p.y + y1,
    }
  }
  _getEndPoint(startP) {
    const p = this.params
    const f = this.staminaPeak ? 1 : this.stamina;
    const x0 = this.staminaFalls ? startP.x : p.x;
    const y0 = this.staminaFalls ? startP.y : p.y;
    const x1 = Math.cos(p.angle) * this.length * f;
    const y1 = Math.sin(p.angle) * this.length * f;
    return {
      x: x0 + x1 * f,
      y: y0 + y1 * f,
    }
  }
  _generateLine() {
    const startPoint = this._getStartPoint();
    const endPoint = this._getEndPoint(startPoint);
    this.geometry = new LineGeometry();
    this.geometry.setPositions( [
      startPoint.x, startPoint.y, 0, 
      endPoint.x, endPoint.y, 0
    ] );
    this.material = new LineMaterial( this.params.materialProps );
    this.material.resolution.set( window.innerWidth, window.innerHeight );
    if (!this.materialVisible)  {
      this.material.visible = false;
    }
    this.line = new Line2( this.geometry, this.material );
    
  }
  _updateLinePositions() {
    const startPoint = this._getStartPoint();
    const endPoint = this._getEndPoint(startPoint);
    if (isNaN(startPoint.x) || isNaN(startPoint.y) || isNaN(endPoint.x) || isNaN(endPoint.y)) {
      return;
    }
    this.geometry.setPositions( [
      startPoint.x, startPoint.y, 0, 
      endPoint.x, endPoint.y, 0
    ] );
    this.geometry.attributes.position.needsUpdate = true;
    // check line material visibility
    const f = this.staminaPeak ? 1 : this.stamina;
    if (f == 0) {
      if (this.materialVisible) {
        this.material.visible = false;
        this.materialVisible = false;
        this.material.needsUpdate = true;
      }
    } else {
      if (!this.materialVisible) {
        this.material.visible = true;
        this.materialVisible = true;
        this.material.needsUpdate = true;
      }
    }
  }
  _getLineStaminaAnimation( subject ) {
    let effectiveLifetime = this.params.lifetime - this.params.delay;
    let timeShow = this.params.animTimeShow;
    let timeHide = this.params.animTimeHide;
    // check if lifetime os longer than 1 sec
    timeShow = effectiveLifetime < (timeShow * 4) ? effectiveLifetime * .2 : timeShow;
    timeHide = effectiveLifetime < (timeHide * 4) ? effectiveLifetime * .2 : timeHide;
    let tl = gsap.timeline({paused: true});
    tl.to (subject, {
      stamina: 1,
      duration: timeShow,
      delay: this.params.delay,
      ease: 'power4.out',
    });
    tl.to (subject, {
      stamina: 0,
      duration: timeHide,
      delay: this.params.lifetime - timeHide,
      ease: 'power4.in',
    }, 0);
    return tl;
  }
  update() {
    if (!this.visible) return;
    this.frame++;
    if (this.frame > this.params.lifetime) {
      this.visible = false;
      return;
    }
    this.staminAnimation.seek(this.frame);
    
    // // test
    // this._updateLength();
    // this._updateLinePositions();

    if (this.stamina == 1) {
      this.staminaPeak = true;
    } else if (this.stamina != this.currentStamina) {
      if (this.currentStamina == 0 && !this.staminaPeak) {
        this._updateLength();
      }
      this.staminaFalls = this.stamina < this.currentStamina;
      this._updateLinePositions();
      this.currentStamina = this.stamina;
    }
  }
  _updateLength() {
    const audioParams = getAccentSoundAnalyserData(this.params.soundId);
    let multiplier = audioParams.gain;
    // let multiplier = audioParams.gain + 1 - this.params.volume;
    multiplier = multiplier > 1 ? 1 : multiplier;
    let l = this.params.length * multiplier;
    l = l > this.params.lengthMax ? this.params.lengthMax : l;
    l = l < this.params.lengthMin ? this.params.lengthMin : l;
    this.length = l;
  }
  show() {
    this.visible = true;
  }
  hide() {
    const frameHide = this.params.lifetime - this.params.animTimeHide;
    if (this.stamina == 0) {
      this.visible = false;
    } else if (this.frame < frameHide) {
      this.frame = frameHide - 1;
    }
  }
  destroyObject() {
    this.visible = false;
    if (this.line) {
      this.line.remove();
      this.line.geometry.dispose();
      this.line.material.dispose();
      this.line = null;
    }
  }
  getObject() {
    return this.line;
  }
  
  
  
  

}

export default Shape;